import * as types from "./provinceTypes";


export const fetchProvinceTypesRequest = () => ({
    type: types.FETCH_PROVINCE_TYPES_REQUEST,
});

export const fetchProvinceTypesSuccess = (provinces) => ({
    type: types.FETCH_PROVINCE_TYPES_SUCCESS,
    payload: provinces,
});

export const fetchProvinceTypesFailure = (error) => ({
    type: types.FETCH_PROVINCE_TYPES_FAILURE,
    payload: error,
});

